import React from 'react';
import { Container, Content } from './style';

function InformacaoDashboard({ informacao, fundoTransparente, tipoTexto }) {
  return (
    <>
      <Container fundoTransparente={fundoTransparente}>
        <Content dangerouslySetInnerHTML={{ __html: informacao }} tipoTexto={tipoTexto} />
      </Container>
    </>
  );
}

export default InformacaoDashboard;
